<template>
    <div id="HomePage">
        <div class="header-wrapper" :class="{'fixed':isFixed}">
            <img class="logo" src="../assets/images/logo.png" alt="" />
            <div class="header-content">
                <ul>
                    <li :class="{'active':activeIndex === 0}" @click="shiftTitle(0)">
                        <span>首页</span>
                    </li>
                    <li :class="{'active':activeIndex === 1}" @click="shiftTitle(1)">
                        <span>小程序下单</span>
                    </li>
                    <li :class="{'active':activeIndex === 2}" @click="shiftTitle(2)">
                        <span>一键下单</span>
                    </li>
                    <li :class="{'active':activeIndex === 3}" @click="shiftTitle(3)">
                        <span>关于极吼吼</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="slogan-content scroll-container clearfix" :class="{'marginTop':isFixed}">
            <div class="fl">
                <h1>60分钟速达</h1>
                <h1>正规维修 专业技术</h1>
                <span>HOHOFAST</span>
            </div>
            <div class="fr">
                <h2>
                    <span>Phone</span>
                    <p>400-11-52766</p>
                </h2>
                <h2 class="city">
                    <span>City</span>
                    <p>SHANGHAI/BEIJING/SHENZHEN</p>
                </h2>
            </div>
        </div>
        <div class="banner-content scroll-container">
            <Carousel
                v-model="bannerValue"
                :autoplay="setting.autoplay"
                :autoplay-speed="setting.autoplaySpeed"
                :dots="setting.dots"
                :radius-dot="setting.radiusDot"
                :trigger="setting.trigger"
                :arrow="setting.arrow"
                loop>
                <CarouselItem>
                    <div class="demo-carousel">
                        <img src="../assets/images/banner.png" alt="" @click="shiftTitle(2)" />
                    </div>
                </CarouselItem>
                <CarouselItem>
                    <div class="demo-carousel">
                        <img src="../assets/images/banner.png" alt="" />
                    </div>
                </CarouselItem>
            </Carousel>
            <div class="mask-content">
                <img src="../assets/images/scan.png" alt="www.allscs.cn" />
                <h1>小程序下单</h1>
                <p>微信扫一扫 极速维修</p>
            </div>
        </div>
        <div class="scroll-container">
            <div class="create-order-contet">
                <h1>一键下单</h1>
                <div class="item">
                    <h2>所在地区</h2>
                    <Row>
                        <Col span="12" style="padding-right:30px">
                            <Select @on-change="selectCity" v-model="params.city" clearable style="height: 44px">
                                <Option
                                    placeholder="请选择城市"
                                    v-for="(item,index) in cityList" 
                                    :value="item.value" 
                                    :key="index">
                                    {{ item.label }}
                                </Option>
                            </Select>
                        </Col>
                        <Col span="12" style="margin-bottom:20px;padding-left: 30px">
                            <Select v-model="params.country" clearable style="height: 44px" >
                                <Option
                                    placeholder="请选择区域"
                                    v-for="(item,index) in countyList" 
                                    :value="item.value" 
                                    :key="index">
                                    {{ item.label }}
                                </Option>
                            </Select>
                        </Col>
                    </Row>
                    <Input v-model="params.address" placeholder="请输入详细地址" style="height: 44px;outline: none"></Input>
                </div>
                <div class="item">
                    <h2>预留信息</h2>
                    <Input v-model="params.customerName" placeholder="姓名" style="height: 44px;outline: none;margin-bottom:20px"></Input>
                    <Row>
                        <Col span="12" style="padding-right:30px">
                            <Input v-model="params.telephoneNo" placeholder="手机号" style="height: 44px;outline: none"></Input>
                        </Col>
                        <Col span="12" style="margin-bottom:20px;padding-left: 30px;position: relative">
                            <Input v-model="vCode" placeholder="验证码" style="height: 44px;outline: none"></Input>
                            <span class="code-btn active" v-if="sendAuthCode"  @click="getAuthCode">获取验证码</span>
                            <span class="code-btn" v-else>{{auth_time}}s</span>
                        </Col>
                    </Row>
                    <p class="submit-btn active" v-if="!isSubmit" @click="submitBtn">立即预约</p>
                    <p class="submit-btn" v-if="isSubmit">立即预约</p>

                </div>
            </div>
            <div class="service-content">
                <img class="bg" src="../assets/images/service.png" alt="" />
                <div class="progress-content">
                    <h1>服务流程</h1>
                    <ul>
                        <transition
                            enter-active-class="animated fadeInRight"
                            leave-active-class="animated fadeOutLeft">
                            <li class="line" v-show="isShow1">
                                <img src="../assets/images/yy.png" alt="" />
                                <p>1.提交预约</p>
                            </li>
                        </transition>
                        <transition
                            enter-active-class="animated fadeInRight"
                            leave-active-class="animated fadeOutLeft">
                            <li class="line" v-show="isShow2">
                                <img src="../assets/images/sl.png" alt="" />
                                <p>2.订单受理</p>
                            </li>                        
                        </transition>
                        <transition
                            enter-active-class="animated fadeInRight"
                            leave-active-class="animated fadeOutLeft">                           
                            <li class="line" v-show="isShow3">
                                <img src="../assets/images/sm.png" alt="" />
                                <p>3.上门维修</p>
                            </li>                        
                        </transition>
                        <transition
                            enter-active-class="animated fadeInRight"
                            leave-active-class="animated fadeOutLeft">
                            <li v-show="isShow4">
                                <img src="../assets/images/wc.png" alt="" />
                                <p>4.完成支付</p>
                            </li>
                        </transition>
                    </ul>
                    
                </div>
            </div>
        </div>
        <div class="footer-wrapper">
            <div class="footer-content clearfix">
                <ul class="fl clearfix">
                    <li>
                        <dl>
                            <dt>服务内容</dt>
                            <dd>
                                <a>故障维修</a>
                            </dd>
                            <dd>
                                <a>内存升级</a>
                            </dd>
                            <dd>
                                <a>手机回收</a>
                            </dd>
                            <dd>
                                <a>企业服务</a>
                            </dd>
                        </dl>
                    </li>
                    <li>
                        <dl>
                            <dt>关于我们</dt>
                            <dd>
                                <a>关于我们</a>
                            </dd>
                            <dd>
                                <a>联系我们</a>
                            </dd>
                            <dd>
                                <a>加入我们</a>
                            </dd>
                        </dl>
                    </li>
                    <li>
                        <dl>
                            <dt>帮助</dt>
                            <dd>
                                <a>服务保障</a>
                            </dd>
                            <dd>
                                <a>常见问题</a>
                            </dd>
                            <dd>
                                <a>服务流程</a>
                            </dd>
                            <dd>
                                <a>线下门店</a>
                            </dd>
                        </dl>
                    </li>
                </ul>
                <ul class="fr clearfix">
                    <li>
                        <img src="../assets/images/gsh.png" alt="" />
                        <p>扫码关注极吼吼</p>
                    </li>
                    <li>
                        <img src="../assets/images/scan.png" alt="" />
                        <p>小程序下单</p>
                    </li>
                </ul>
            </div>
            <BackTop :height="400"></BackTop>
            <p class="copyright">Copyright&nbsp;&nbsp;极吼吼&nbsp;&nbsp;©&nbsp;&nbsp;2018-2022&nbsp;&nbsp;&nbsp;&nbsp;<a style="text-decoration: none;color:#656565;" class="ui-link" href="http://beian.miit.gov.cn">沪ICP备15055722号-1</a>&nbsp;&nbsp;&nbsp;&nbsp;
        <a  class="ui-link" style="text-decoration:none;color:#656565;" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502001871"><img class="ui-img" src="../assets/images/sh.png">&nbsp;沪公网安备 31010502001871号</a>
        </p>
        
        </div>
        <!-- <showToast ref="myToast"></showToast> -->
    </div>
</template>
<script type="text/javascript">document.write(unescape("%3Cspan id='cnzz_stat_icon_1280724980'%3E%3C/span%3E%3Cscript src='https://v1.cnzz.com/z_stat.php%3Fid%3D1280724980%26show%3Dpic' type='text/javascript'%3E%3C/script%3E"));</script>
<script>
    import Vue from 'vue';
    import {Carousel,BackTop} from 'iview';
    import { cityData,createVcode,vertifyCode,createOrder } from "@/api/api";
    export default{
        components:{
            Carousel,
            BackTop
        },
        data(){
            return{
                isShow1:false,
                isShow2:false,
                isShow3:false,
                isShow4:false,
                isFixed:false,
                activeIndex:-1,
                bannerValue:0,
                isSubmit:false,
                setting: {
                    autoplay: true,
                    autoplaySpeed: 2000,
                    dots: 'inside',
                    radiusDot: false,
                    trigger: 'click',
                    arrow: 'never'
                },
                returnData:[],
                cityList: [],
                countyList:[],
                vCode:'',
                params:{
                    city:'',
                    province:'',
                    country:'',
                    address:'',
                    telephoneNo:'',
                    customerName:''
                },
                sendAuthCode:true,/*布尔值，通过v-show控制显示‘获取按钮’还是‘倒计时’ */
                auth_time: 0,     /*倒计时 计数器*/
            }
        },
        mounted(){
            //页面加载后添加滚动事件
            this.$nextTick(function () {
                window.addEventListener('scroll', this.onScroll);
            });
            setTimeout(()=>{
                if(sessionStorage.getItem('activeIndex') != null){
                    this.jump(Number(sessionStorage.getItem('activeIndex')));
                }else{
                    this.jump(0);
                }
            },10);
            this.getCityData();        
        },
        destroyed: function () {
            //离开页面清除（移除）滚轮滚动事件
            window.removeEventListener('scroll', this.onScroll);
        },
        methods:{
            //选择城市
            selectCity(e){
                this.countyList = [];
                this.returnData.forEach((item,index)=>{
                    if(e == item.city){
                        this.params.province = item.province;
                        item.countyList.forEach((item1,index1)=>{
                            this.countyList.push({
                                value: item1.county,
                                label: item1.countyName
                            })
                        })   
                    }
                });
            },
            //获取市区数据
            getCityData(){
                cityData({}).then(res => {
                    this.cityList = [];
                    if (res.data.status == "100") {
                        this.returnData = res.data.results;
                        this.returnData.forEach((item,index)=>{
                            this.cityList.push({
                                value:item.city,
                                label:item.cityName,
                                province:item.province
                            });
                        });
                    }else{
                        this.$Message.error(res.data.message);
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //验证码倒计时
            getCountDown(){
                this.sendAuthCode = false;
                this.auth_time = 59;
                let auth_timetimer =  setInterval(()=>{
                    this.auth_time--;
                    if(this.auth_time<=0){
                        this.sendAuthCode = true;
                        clearInterval(auth_timetimer);
                    }
                }, 1000);
            },
            //点击获取验证码
            getAuthCode:function () {
                if(!this.params.city){
                    this.$showToast('请选择城市');
                    return;
                }
                if(!this.params.country){
                    this.$showToast('请选择地区');
                    return;
                }
                if(!this.params.customerName){
                    this.$showToast('请输入姓名');
                    return;
                }
                if(!this.params.telephoneNo){
                    this.$showToast('请输入手机号码');
                    return;
                }
                if(!this.params.telephoneNo){
                    this.$showToast('请输入手机号码');
                    return;
                }
                if(!this.params.telephoneNo.match(/^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/)){
                    this.$showToast('手机号码格式不正确');
                    return;
                }
                this.getCountDown(); //验证码倒计时
                createVcode({telephoneNo:this.params.telephoneNo}).then(res => {
                    if (res.data.status == "100") {
                        this.$showToast(res.data.message);
                    }else{
                        this.$Message.error(res.data.message);
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
                
            },
            //校验验证码
            codeAuth(){
                vertifyCode({telephoneNo:this.params.telephoneNo,vCode:this.vCode}).then(res => {
                    if (res.data.status == "100") {

                        this.submitHttp();
                    }else{
                        let msg = ""
                        if(!this.sendAuthCode){
                            msg = "验证码错误"
                        }else{
                            msg = "请获取验证码"
                        }
                        this.$showToast(msg);
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //立即预约
            submitBtn(){
                if(!this.params.city){
                    this.$showToast('请选择城市');
                    return;
                }
                if(!this.params.country){
                    this.$showToast('请选择区域');
                    return;
                }
                if(!this.params.address){
                    this.$showToast('请输入详细地址');
                    return;
                }
                if(!this.params.customerName){
                    this.$showToast('请输入姓名');
                    return;
                }
                if(!this.params.telephoneNo){
                    this.$showToast('请输入手机号码');
                    return;
                }
                if(!this.params.telephoneNo.match(/^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/)){
                    this.$showToast('手机号码格式不正确');
                    return;
                }
                if(!this.vCode){
                    this.$showToast('请获取验证码');
                    return
                }
                this.codeAuth();
            },
            //提交接口
            submitHttp(){
                this.isSubmit = true;
                let params = {
                    orderIdentifier:'PC',
                    clientBasicInformation:{
                        customerName:this.params.customerName,
                        telephoneNo:this.params.telephoneNo,
                        province:this.params.province,
                        city:this.params.city,
                        county:this.params.country,
                        address:this.params.address
                    }
                }
                createOrder(params).then(res => {
                    if (res.data.status == "100") {
                        this.$showToast(res.data.message);
                        this.isSubmit = false;
                        this.auth_time = 0;
                        Object.keys(this.params).forEach(key => this.params[key] = '');
                    }else{
                        this.$showToast(res.data.message);
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //导航跳转
            shiftTitle(index){
                if(index < 3){
                    this.jump(index);
                }else{
                    this.$router.replace('/aboutUs');
                }
                //清除activeIndex缓存
                if(sessionStorage.getItem('activeIndex') != null){
                    sessionStorage.removeItem('activeIndex')
                }
            },
            //滚动指定位置
            toTop(scrollTop){
                document.body.scrollTop = scrollTop;
                document.documentElement.scrollTop = scrollTop;
                window.pageYOffset = scrollTop;
            },
            //滚动函数
            onScroll () {
                //获取滚动对象到窗体顶部的距离 chrome&Firefox&Safari
                let scrolled = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
                if (scrolled < 2025 && scrolled >= 900) {
                    this.activeIndex = 2;
                } else if (scrolled < 900 && scrolled >= 300) {
                    this.activeIndex = 1;
                } else if(scrolled < 5){
                    this.activeIndex = 0;
                    //滚动清零
                    this.toTop(0);
                }
                this.isShow1 = scrolled > 1400 ? true : false;
                let timer1 = setTimeout(()=>{
                    this.isShow2 = scrolled > 1400 ? true : false;
                    clearTimeout(timer1);
                },50);
                let timer2 = setTimeout(()=>{
                    this.isShow3 = scrolled > 1400 ? true : false;
                    clearTimeout(timer2);
                },100);
                let timer3 = setTimeout(()=>{
                    this.isShow4 = scrolled > 1400 ? true : false;
                    clearTimeout(timer3);
                },150);
                this.isFixed = (this.activeIndex == 0) ? false : true;
            },
            //锚点平滑跳转
            jump(index){
                let jump = document.querySelectorAll('.scroll-container');
                let total = jump[index].offsetTop > 102 ?  jump[index].offsetTop - 102 : 0;
                let distance = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
                // 平滑滚动，时长500ms，每5ms一跳，共100跳
                let step = total / 50;
                if(distance <= 0 && total <= 0){
                    this.activeIndex = 0;
                    return
                }
                if (total >= distance) {
                    smoothDown();
                } else {
                    let newTotal = distance - total;
                    step = newTotal / 50;
                    smoothUp();
                }
                function smoothDown () {
                    if (distance <= total) {
                        distance += step;
            　　　　　   document.body.scrollTop = distance;
                        document.documentElement.scrollTop = distance;
                        window.pageYOffset = distance;
                        setTimeout(smoothDown, 5);
                    } else {
                        document.body.scrollTop = total;
                        document.documentElement.scrollTop = total;
                        window.pageYOffset = total;
                    }
                }
                function smoothUp () {
                    if (distance > total) {
                        distance -= step;
            　　　　　　 document.body.scrollTop = distance;
                        document.documentElement.scrollTop = distance;
                        window.pageYOffset = distance;
                        setTimeout(smoothUp, 5);
                    } else {
                        document.body.scrollTop = total;
                        document.documentElement.scrollTop = total;
                        window.pageYOffset = total;
                    }
                } 
            }
        }
    }
</script>

<style lang="less">
    .ivu-select{
        height: 44px;
    }
    #HomePage{
        .header-wrapper{
            position: relative;
            padding:57px 140px 0;
            border-bottom:1px solid #f5f5f5;
            transition: .5s;
            position: fixed;
            width: 100%;
            left:0;
            top:0;
            background:rgba(255,255,255,.8);
            z-index:99;
            transition: .3s;
            img.logo{
                position: absolute;
                left:140px;
                top:10px;
                width: 103px;
                height: 103px;
            }
            .header-content{
                width: 630px;
                margin:0 auto ;
                height: 44px;
                ul{
                    display: -webkit-box; /* Chrome 4+, Safari 3.1, iOS Safari 3.2+ */  
                    display: -moz-box; /* Firefox 17- */  
                    display: -webkit-flex; /* Chrome 21+, Safari 6.1+, iOS Safari 7+, Opera 15/16 */  
                    display: -moz-flex; /* Firefox 18+ */  
                    display: -ms-flexbox; /* IE 10 */  
                    display: flex; /* Chrome 29+, Firefox 22+, IE 11+, Opera 12.1/17/18, Android 4.4+ */
                    -webkit-box-pack: justify;
                    -ms-flex-pack: justify;
                    -webkit-justify-content: space-between;
                    justify-content: space-between;
                    li{
                        text-align:center;
                        line-height:1.8;
                        width: 80px;
                        span{
                            font-size:16px;
                            font-family:PingFang SC;
                            font-weight:500;
                            color:rgba(196,196,196,1);
                            display:block;
                            height: 44px;
                            position: relative;
                            cursor:pointer;
                            -moz-user-select: none;
                            -webkit-user-select: none;
                            -ms-user-select: none;
                            &:after{
                                content:'';
                                position:absolute;
                                left:32%;
                                bottom:0;
                                width: 36%;
                                height:4px;
                                display:block;
                                background: transparent;
                                border-radius:4px;
                            }
                        }
                    }
                    li.active{
                        span{
                            color:rgba(29,29,29,1);
                            font-weight:bold;
                            &:after{
                                background: #1D1D1D;
                            }
                        }
                    }
                }
            } 
        }
        .fixed{
            box-shadow: 0 5px 5px -5px #eee;
            .header-content{
                ul{
                    li{
                        span{
                            color:rgba(29,29,29,1);
                        }
                    }
                    li.active{
                        span{
                            color:#535dfa;
                            &:after{
                                background: #535dfa;
                            }
                        }
                    }
                }
            }
        }
        .slogan-content{
            box-sizing:border-box;
            padding:168px 0 66px;
            .fl,.fr{
                width: 49%;
            }
            .fl{
                h1{
                    font-size:40px;
                    font-family:PingFang SC;
                    font-weight:600;
                    line-height:1.8;
                    color:rgba(29,29,29,1);
                    opacity:1;
                }
                span{
                    display:block;
                    margin-top:10px;
                    font-size:16px;
                    font-family:Gilroy-Bold;
                    font-weight:normal;
                    line-height:1.8;
                    color:rgba(196,196,196,1);
                    opacity:1;
                }
            }
            .fr{
                h2{
                    span{
                        display:block;
                        font-size:16px;
                        font-family:Gilroy-Bold;
                        font-weight:normal;
                        line-height:1.8;
                        color:rgba(196,196,196,1);
                        opacity:1;
                    }
                    p{
                        font-size:16px;
                        font-family:Gilroy-Bold;
                        font-weight:normal;
                        line-height:1.8;
                        color:rgba(101,101,101,1);
                        opacity:1;
                    }
                }
                h2.city{
                    margin-top:34px;
                }
            }
        }
        .banner-content{
            position: relative;
            margin-bottom:100px;
            .demo-carousel{
                img{
                    width: 100%;
                    display:block;
                    height: auto;
                }
            }
            .mask-content{
                position: absolute;
                width: 100%;
                height: 100%;
                left:0;
                top:0;
                text-align:center;
                background: rgba(0,0,0,.3);
                img{
                    width: 140px;
                    height: 140px;
                    display:block;
                    margin:300px auto 56px;
                }
                h1{
                    font-size:40px;
                    font-family:PingFang SC;
                    font-weight:600;
                    line-height:56px;
                    color:rgba(255,255,255,1);
                    opacity:1;
                }
                p{
                    font-size:16px;
                    font-family:PingFang SC;
                    font-weight:500;
                    line-height:22px;
                    color:rgba(255,255,255,1);
                    opacity:1;
                }
            }
        }
        .create-order-contet{
            width: 700px;
            margin:0 auto 100px;
            h1{
                font-size:40px;
                font-family:PingFang SC;
                font-weight:600;
                color:rgba(29,29,29,1);
                opacity:1;
                margin-bottom:100px;
            }
            .item{
                margin-bottom:57px;
                h2{
                    font-size:14px;
                    font-family:PingFang SC;
                    font-weight:500;
                    line-height:20px;
                    color:rgba(29,29,29,1);
                    opacity:1;
                    text-align:left;
                    margin-bottom: 20px
                }
                span.code-btn{
                    position: absolute;
                    right:0;
                    display:block;
                    width:100px;
                    height:40px;
                    background:#ccc;
                    opacity:1;
                    border-radius:20px;
                    line-height:40px;
                    text-align:center;
                    font-size:14px;
                    font-family:PingFang SC;
                    font-weight:400;
                    color:rgba(255,255,255,1);
                    opacity:1;
                    top:10px;
                    cursor:pointer;
                    -moz-user-select: none;
                    -webkit-user-select: none;
                    -ms-user-select: none;
                }
                span.active{
                    background:rgba(83,93,250,1);
                }
                p.submit-btn{
                    width:300px;
                    height:60px;
                    line-height:60px;
                    background:#ccc;
                    opacity:1;
                    border-radius:5px;
                    margin:60px auto 0;
                    text-align:center;
                    color:#fff;
                    font-size:20px;
                    font-family:PingFang SC;
                    font-weight:500;
                    color:rgba(255,255,255,1);
                    opacity:1;
                    cursor: pointer;
                    -moz-user-select: none;
                    -webkit-user-select: none;
                    -ms-user-select: none;
                }
                p.active{
                    background:rgba(83,93,250,1);
                }
            }

        }
        .service-content{
            margin-bottom:20px;
            position: relative;

            img.bg{
                width: 100%;
                height: auto;
                display:block;
            }
            .progress-content{
                position: absolute;
                width: 100%;
                height: 100%;
                left:0;
                top:0;
                background:rgba(0,0,0,.3);
                h1{
                    font-size:40px;
                    font-family:PingFang SC;
                    font-weight:500;
                    text-align:center;
                    color:rgba(255,255,255,1);
                    opacity:1;
                    margin-top:130px;
                }
                ul{
                    width: 812px;
                    margin:96px auto 0;
                    display: -webkit-box; /* Chrome 4+, Safari 3.1, iOS Safari 3.2+ */  
                    display: -moz-box; /* Firefox 17- */  
                    display: -webkit-flex; /* Chrome 21+, Safari 6.1+, iOS Safari 7+, Opera 15/16 */  
                    display: -moz-flex; /* Firefox 18+ */  
                    display: -ms-flexbox; /* IE 10 */  
                    display: flex; /* Chrome 29+, Firefox 22+, IE 11+, Opera 12.1/17/18, Android 4.4+ */
                    -webkit-box-pack: justify;
                    -ms-flex-pack: justify;
                    -webkit-justify-content: space-between;
                    justify-content: space-between;
                    li{
                        width: 100px;
                        img{
                            width: 100px;
                            height: 100px;
                            display:block;
                        }
                        p{
                            font-size:14px;
                            font-family:PingFang SC;
                            font-weight:500;
                            text-align:center;
                            color:rgba(255,255,255,1);
                            opacity:1;
                            margin-top:20px;
                        }
                    }
                    li.line{
                        position: relative;
                        &:after{
                            content: "";
                            display:block;
                            position: absolute;
                            width: 100px;
                            left:119px;
                            height:0px;
                            border:1px dashed rgba(235,235,235,1);
                            opacity:1;
                            top:44px;
                        }
                    }

                }
            }
        }
        .footer-wrapper{
            .footer-content{
                width: 1088px;
                margin:90px auto;
                ul{
                    display: -webkit-box; /* Chrome 4+, Safari 3.1, iOS Safari 3.2+ */  
                    display: -moz-box; /* Firefox 17- */  
                    display: -webkit-flex; /* Chrome 21+, Safari 6.1+, iOS Safari 7+, Opera 15/16 */  
                    display: -moz-flex; /* Firefox 18+ */  
                    display: -ms-flexbox; /* IE 10 */  
                    display: flex; /* Chrome 29+, Firefox 22+, IE 11+, Opera 12.1/17/18, Android 4.4+ */
                    -webkit-box-pack: justify;
                    -ms-flex-pack: justify;
                    -webkit-justify-content: space-between;
                    justify-content: space-between;
                    box-sizing: border-box;
                }
                ul.fl{
                    width: 593px;
                    li{
                        dl{
                            text-align:left;
                            dt{
                                font-size:18px;
                                font-family:PingFang SC;
                                font-weight:500;
                                color:rgba(101,101,101,1);
                                opacity:1;
                                margin-bottom:20px;
                            }
                            dd{
                                font-size:14px;
                                font-family:PingFang SC;
                                font-weight:500;
                                line-height:2;
                                
                                opacity:1;
                                a{
                                    color:rgba(196,196,196,1);
                                    -moz-user-select: none;
                                    -webkit-user-select: none;
                                    -ms-user-select: none;
                                }
                            }
                        }
                    }
                }
                ul.fr{
                    width: 288px;
                    li{
                        width: 120px;

                        img{
                            width: 110px;
                            height: 110px;
                            display:block;
                            margin:5px auto 17px;
                        }
                        p{
                            font-size:14px;
                            font-family:PingFang SC;
                            font-weight:500;
                            line-height:1.8;
                            color:rgba(196,196,196,1);
                            opacity:1;
                            text-align:center;
                        }
                    }
                }
            }
            .copyright{
                font-size:14px;
                font-family:PingFang SC;
                font-weight:400;
                line-height:60px;
                color:rgba(101,101,101,1);
                opacity:1;
                border-top:1px solid #f5f5f5;
                border-bottom:1px solid #f5f5f5;
                text-align:center;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/Home.vue